<div class="main-wrapper" [class.preview-active]="showFormPreview">
  <!-- ===== LEFT PANEL ===== -->
  <aside class="left-panel" [ngClass]="{ 'left-panel--collapsed': !showStepper }">
    <div class="gradient-overlay"></div>
    <div class="floating-blob blob-1"></div>
    <div class="floating-blob blob-2"></div>
    <div class="line-pattern"></div>

    <!-- Toggle Button — always visible -->
    <button class="stepper-toggle-btn" type="button" (click)="toggleStepper()"
      [title]="showStepper ? 'Collapse sidebar' : 'Expand sidebar'">
      <i class="bi bi-chevron-double-left toggle-icon" [class.rotated]="!showStepper"></i>
    </button>

    <!-- Mini Stepper — visible only when sidebar is collapsed -->
    <div class="mini-stepper" *ngIf="!showStepper">
      <div class="mini-step-item" *ngFor="let i of [0, 1, 2, 3, 4]" [class.active]="activeStep === i"
        [class.completed]="isStepCompleted(i)" (click)="setStep(i)" [title]="
          [
            'Initial Verification',
            'Firm Details',
            'Address Details',
            'Categories',
            'Upload Documents',
          ][i]
        ">
        <div class="mini-step-circle">
          <i *ngIf="isStepCompleted(i)" class="bi bi-check2"></i>
          <span *ngIf="!isStepCompleted(i)">{{ i + 1 }}</span>
        </div>
        <div class="mini-connector" *ngIf="i < 4"></div>
      </div>
    </div>

    <div class="left-content-wrap" [class.stepper-content--hidden]="!showStepper" [class.stepper-ready]="stepperReady">
      <div class="logo-area">
        <div class="logo-circle">
          <img src="TNPGCL_logo.png" alt="TNPGCL Logo" />
        </div>
        <div class="logo-labels">
          <h1 class="portal-title-text">Ash <span class="green-accent">Disposal Portal</span></h1>
        </div>
      </div>

      <!-- Stepper -->
      <div class="stepper">
        <div class="step-item" [class.active]="activeStep === 0" [class.completed]="isStepCompleted(0)"
          (click)="setStep(0)">
          <div class="step-circle" [class.active]="activeStep === 0" [class.completed]="isStepCompleted(0)">
            <span *ngIf="!isStepCompleted(0)">1</span>
            <i *ngIf="isStepCompleted(0)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">STATION & TYPE</div>
            <div class="step-desc">Mobile & Station</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(0)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 0 && !isStepCompleted(0)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 1" [class.completed]="isStepCompleted(1)"
          (click)="setStep(1)">
          <div class="step-circle" [class.active]="activeStep === 1" [class.completed]="isStepCompleted(1)">
            <span *ngIf="!isStepCompleted(1)">2</span>
            <i *ngIf="isStepCompleted(1)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">AGENCY DETAILS</div>
            <div class="step-desc">Agency & Contact Info</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(1)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 1 && !isStepCompleted(1)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 2" [class.completed]="isStepCompleted(2)"
          (click)="setStep(2)">
          <div class="step-circle" [class.active]="activeStep === 2" [class.completed]="isStepCompleted(2)">
            <span *ngIf="!isStepCompleted(2)">3</span>
            <i *ngIf="isStepCompleted(2)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">AGENCY ADDRESS</div>
            <div class="step-desc">Site & Company Location</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(2)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 2 && !isStepCompleted(2)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 3" [class.completed]="isStepCompleted(3)"
          (click)="setStep(3)">
          <div class="step-circle" [class.active]="activeStep === 3" [class.completed]="isStepCompleted(3)">
            <span *ngIf="!isStepCompleted(3)">4</span>
            <i *ngIf="isStepCompleted(3)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">CATEGORIES</div>
            <div class="step-desc">Non-Mnfg & Ash</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(3)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 3 && !isStepCompleted(3)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 4" [class.completed]="isStepCompleted(4)"
          (click)="setStep(4)">
          <div class="step-circle" [class.active]="activeStep === 4" [class.completed]="isStepCompleted(4)">
            <span *ngIf="!isStepCompleted(4)">5</span>
            <i *ngIf="isStepCompleted(4)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">UPLOAD DOCUMENTS</div>
            <div class="step-desc">Clearances & Declarations</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(4)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 4 && !isStepCompleted(4)">Active</span>
          </div>
        </div>
      </div>
    </div>
  </aside>

  <!-- ===== RIGHT PANEL ===== -->
  <main class="right-panel">
    <!-- ===== HERO BANNER ===== -->
    <div class="hero-banner" *ngIf="!showFormPreview">
      <div class="hero-banner-inner">
        <div class="hero-text-content">
          <div class="hero-badge">
            <span class="hero-badge-dot"></span>
            Tamil Nadu Power Generation Corporation Limited
          </div>
          <h1 class="hero-title">
            Non-Manufacturing <span class="hero-title-highlight">Registration</span>
          </h1>
          <p class="hero-subtitle">
            Register your organization and manage ash allocation digitally.
          </p>
        </div>
      </div>
    </div>

    <div class="form-card">
      <!-- Resume Draft action -->
      <div class="form-card-actions" *ngIf="activeStep < 4 && !showFormPreview">
        <button type="button" class="btn-resume-draft" (click)="onResumeDraft()" [disabled]="isLoadingDraft">
          <span *ngIf="isLoadingDraft" class="spinner-border spinner-border-sm me-1" role="status"
            aria-hidden="true"></span>
          <i *ngIf="!isLoadingDraft" class="bi bi-arrow-counterclockwise"></i>
          {{ isLoadingDraft ? 'Loading Draft...' : 'Resume Draft' }}
        </button>
      </div>

      <!-- Progress bar — flush top of card, no inner box -->
      <div class="form-progress-bar" *ngIf="!showFormPreview">
        <div class="form-progress-fill" [style.width.%]="getProgressPercent()"></div>
      </div>

      <form [formGroup]="registerForm" *ngIf="!showFormPreview" class="main-register-form">
        <!-- Step 1: Station & Type (activeStep === 0) -->
        <div class="form-step" *ngIf="activeStep === 0">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-shield-check"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Station & Type</h3>
          </div>
          <p class="section-desc">
            Provide the power station you are allocating from and verify your mobile number.
          </p>

          <div class="row row-gap g-3">
            <!-- Mobile Number -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Mobile Number <span class="required-star">*</span></label>
              <div class="phone-group">
                <div class="phone-prefix">
                  <span class="flag-emoji">🇮🇳</span>
                  <span>+91</span>
                </div>
                <input type="tel" class="form-control phone-input" placeholder="Enter 10-digit mobile number"
                  formControlName="mobileNumber" maxlength="10"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57;" />
              </div>
              <div *ngIf="
                  registerForm.get('mobileNumber')?.touched ||
                  (registerForm.get('mobileNumber')?.dirty &&
                    registerForm.get('mobileNumber')?.value?.length === 10)
                " class="mt-1" style="font-size: 11.5px; font-weight: 500">
                <div *ngIf="mobileCheckStatus === 'checking'" class="text-primary">
                  <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  Checking mobile number...
                </div>
                <div *ngIf="mobileCheckStatus === 'valid'" class="text-success">
                  <i class="bi bi-check-circle-fill"></i> Mobile number is valid.
                </div>
                <div *ngIf="
                    mobileCheckStatus === 'exists' ||
                    registerForm.get('mobileNumber')?.errors?.['alreadyRegistered']
                  " class="text-danger">
                  <i class="bi bi-exclamation-circle-fill"></i>
                  {{ mobileCheckErrorMsg || 'This mobile number is already registered!' }}
                </div>
                <div *ngIf="
                    registerForm.get('mobileNumber')?.errors?.['required'] &&
                    mobileCheckStatus !== 'exists'
                  " class="text-danger">
                  Mobile number is required.
                </div>
                <div *ngIf="
                    registerForm.get('mobileNumber')?.errors?.['pattern'] &&
                    mobileCheckStatus !== 'exists'
                  " class="text-danger">
                  Must be a valid 10-digit number.
                </div>
              </div>

              <div *ngIf="canGenerateMobileOtp" class="mobile-otp-actions mt-2">
                <button type="button" class="btn-generate-otp" (click)="onGenerateMobileOtp()"
                  [disabled]="mobileOtpGenerating">
                  <span *ngIf="!mobileOtpGenerating">
                    <i class="bi bi-shield-lock"></i> Generate OTP
                  </span>
                  <span *ngIf="mobileOtpGenerating">
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    Generating OTP...
                  </span>
                </button>
              </div>

              <div *ngIf="mobileOtpSent && !mobileOtpVerified" class="mobile-otp-section mt-3"
                [formGroup]="mobileOtpForm">
                <div *ngIf="mobileOtpSuccess" class="mobile-otp-success">
                  <i class="bi bi-check-circle-fill"></i> {{ mobileOtpSuccess }}
                </div>

                <button type="button" class="btn-change-mobile" (click)="changeMobileNumber()">
                  <i class="bi bi-arrow-left"></i> Change mobile number
                </button>

                <label class="form-label mt-2">Enter 4-Digit OTP</label>
                <div class="mobile-otp-input-group" (paste)="onMobileOtpPaste($event)">
                  <input *ngFor="let field of mobileOtpFields; let i = index" [id]="field" type="text"
                    inputmode="numeric" maxlength="1" class="mobile-otp-input" [formControlName]="field"
                    autocomplete="one-time-code" (input)="onMobileOtpInput($event, field, i < 3 ? 'otp' + (i + 2) : '')"
                    (keydown)="onMobileOtpKeydown($event, field, i > 0 ? 'otp' + i : '')" />
                </div>
                <div *ngIf="mobileOtpForm.touched && !isMobileOtpComplete" class="text-danger mt-1"
                  style="font-size: 11.5px; font-weight: 500">
                  OTP is required. Please enter all 4 digits.
                </div>

                <div class="mobile-resend-row mt-2">
                  <span>Didn't receive the code?</span>
                  <button type="button" class="btn-resend-mobile-otp" (click)="onResendMobileOtp()" [disabled]="
                      mobileOtpResendCountdown > 0 || mobileOtpResendLoading || mobileOtpVerifying
                    ">
                    <span *ngIf="mobileOtpResendLoading">Resending...</span>
                    <span *ngIf="!mobileOtpResendLoading && mobileOtpResendCountdown > 0">
                      Resend OTP in {{ mobileOtpResendCountdown }}s
                    </span>
                    <span *ngIf="!mobileOtpResendLoading && mobileOtpResendCountdown === 0">
                      Resend OTP
                    </span>
                  </button>
                </div>

                <div *ngIf="mobileOtpError" class="mobile-otp-error mt-2">
                  <i class="bi bi-exclamation-circle-fill"></i> {{ mobileOtpError }}
                </div>

                <button type="button" class="btn-verify-mobile-otp mt-2" (click)="onVerifyMobileOtp()"
                  [disabled]="mobileOtpVerifying || !isMobileOtpComplete">
                  <span *ngIf="!mobileOtpVerifying">
                    <i class="bi bi-shield-check"></i> Verify OTP
                  </span>
                  <span *ngIf="mobileOtpVerifying">
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    Verifying...
                  </span>
                </button>
              </div>

              <div *ngIf="mobileOtpVerified" class="text-success mt-2" style="font-size: 11.5px; font-weight: 600">
                <i class="bi bi-patch-check-fill"></i> Mobile number verified successfully.
              </div>
            </div>

            <!-- Power Station Dropdown -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Power Station <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-building input-icon"></i>
                <select class="form-select" formControlName="station" style="padding-left: 40px">
                  <option value="" disabled selected>Select Power Station</option>
                  <option *ngFor="let station of powerStations" [value]="station.id">
                    {{ station.name }}
                  </option>
                </select>
              </div>
              <div *ngIf="registerForm.get('station')?.touched && registerForm.get('station')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Power station is required.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 2: Firm Details (activeStep === 1) -->
        <div class="form-step" *ngIf="activeStep === 1">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-buildings-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Agency Details</h3>
          </div>
          <p class="section-desc">Provide your agency information and contact details.</p>

          <div class="col-md-12 mb-3">
            <!-- Name of the Agency -->
            <div class="col-md-12 mb-3">
              <label class="form-label">Name of the Agency <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-building input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter full agency name"
                  formControlName="firmName" />
              </div>
              <div *ngIf="
                  registerForm.get('firmName')?.touched && registerForm.get('firmName')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('firmName')?.errors?.['required']">Agency name is required.</span>
              </div>
            </div>

            <!-- Email Address -->
            <div class="row align-items-start">
              <div class="col-md-6 mb-3">
                <label class="form-label">Email Address <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-envelope input-icon"></i>
                  <input type="email" class="form-control" placeholder="Enter official email"
                    formControlName="emailAddress" />
                </div>
                <div *ngIf="
                    registerForm.get('emailAddress')?.touched ||
                    registerForm.get('emailAddress')?.dirty
                  " class="mt-1" style="font-size: 11.5px; font-weight: 500">
                  <div *ngIf="emailCheckStatus === 'checking'" class="text-primary">
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    Checking email address...
                  </div>
                  <div *ngIf="emailCheckStatus === 'valid'" class="text-success">
                    <i class="bi bi-check-circle-fill"></i> Email is available.
                  </div>
                  <div *ngIf="
                      emailCheckStatus === 'exists' ||
                      registerForm.get('emailAddress')?.errors?.['alreadyRegistered']
                    " class="text-danger">
                    <i class="bi bi-exclamation-circle-fill"></i>
                    {{ emailCheckErrorMsg || 'This email address is already registered!' }}
                  </div>
                  <div *ngIf="
                      registerForm.get('emailAddress')?.errors?.['required'] &&
                      emailCheckStatus !== 'exists'
                    " class="text-danger">
                    Email address is required.
                  </div>
                  <div *ngIf="
                      (registerForm.get('emailAddress')?.errors?.['email'] || registerForm.get('emailAddress')?.errors?.['pattern']) &&
                      emailCheckStatus !== 'exists'
                    " class="text-danger">
                    Please enter a valid email address.
                  </div>
                </div>

                <div *ngIf="canGenerateEmailOtp" class="mobile-otp-actions mt-2">
                  <button type="button" class="btn-generate-otp" (click)="onGenerateEmailOtp()"
                    [disabled]="emailOtpGenerating">
                    <span *ngIf="!emailOtpGenerating"><i class="bi bi-shield-lock"></i> Generate OTP</span>
                    <span *ngIf="emailOtpGenerating">
                      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                      Generating OTP...
                    </span>
                  </button>
                </div>

                <div *ngIf="emailOtpSent && !emailOtpVerified" class="mobile-otp-section mt-3"
                  [formGroup]="emailOtpForm">
                  <div *ngIf="emailOtpSuccess" class="mobile-otp-success">
                    <i class="bi bi-check-circle-fill"></i> {{ emailOtpSuccess }}
                  </div>
                  <button type="button" class="btn-change-mobile" (click)="changeEmailAddress()">
                    <i class="bi bi-arrow-left"></i> Change email address
                  </button>

                  <label class="form-label mt-2">Enter 4-Digit OTP</label>
                  <div class="mobile-otp-input-group" (paste)="onEmailOtpPaste($event)">
                    <input *ngFor="let field of emailOtpFields; let i = index" [id]="field" type="text"
                      inputmode="numeric" maxlength="1" class="mobile-otp-input" [formControlName]="field"
                      autocomplete="one-time-code"
                      (input)="onEmailOtpInput($event, field, i < 3 ? 'emailOtp' + (i + 2) : '')"
                      (keydown)="onEmailOtpKeydown($event, field, i > 0 ? 'emailOtp' + i : '')" />
                  </div>
                  <div *ngIf="emailOtpForm.touched && !isEmailOtpComplete" class="text-danger mt-1"
                    style="font-size: 11.5px; font-weight: 500">
                    OTP is required. Please enter all 4 digits.
                  </div>

                  <div class="mobile-resend-row mt-2">
                    <span>Didn't receive the code?</span>
                    <button type="button" class="btn-resend-mobile-otp" (click)="onResendEmailOtp()" [disabled]="
                        emailOtpResendCountdown > 0 || emailOtpResendLoading || emailOtpVerifying
                      ">
                      <span *ngIf="emailOtpResendLoading">Resending...</span>
                      <span *ngIf="!emailOtpResendLoading && emailOtpResendCountdown > 0">Resend OTP in {{
                        emailOtpResendCountdown }}s</span>
                      <span *ngIf="!emailOtpResendLoading && emailOtpResendCountdown === 0">Resend OTP</span>
                    </button>
                  </div>
                  <div *ngIf="emailOtpError" class="mobile-otp-error mt-2">
                    <i class="bi bi-exclamation-circle-fill"></i> {{ emailOtpError }}
                  </div>
                  <button type="button" class="btn-verify-mobile-otp mt-2" (click)="onVerifyEmailOtp()"
                    [disabled]="emailOtpVerifying || !isEmailOtpComplete">
                    <span *ngIf="!emailOtpVerifying"><i class="bi bi-shield-check"></i> Verify OTP</span>
                    <span *ngIf="emailOtpVerifying">
                      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                      Verifying...
                    </span>
                  </button>
                </div>
                <div *ngIf="emailOtpVerified" class="text-success mt-2" style="font-size: 11.5px; font-weight: 600">
                  <i class="bi bi-patch-check-fill"></i> Email address verified successfully.
                </div>
              </div>

              <!-- Identity Proof Number -->
              <div class="col-md-6 mb-3">
                <label class="form-label">
                  Enter Details of Identity Proof (Aadhaar / DL / Passport)
                  <span class="required-star">*</span>

                  <span class="custom-tooltip-wrapper">
                    <i class="bi bi-info-circle-fill ms-1 info-tooltip-icon"></i>

                    <span class="custom-tooltip-text identity-tooltip">
                      <a href="https://myaadhaar.uidai.gov.in/" target="_blank" class="tooltip-link">
                        <i class="bi bi-person-vcard me-2"></i>Aadhaar
                      </a>

                      <a href="https://parivahan.gov.in/" target="_blank" class="tooltip-link">
                        <i class="bi bi-car-front me-2"></i>Driving Licence
                      </a>

                      <a href="https://www.passportindia.gov.in/" target="_blank" class="tooltip-link">
                        <i class="bi bi-passport me-2"></i>Passport
                      </a>
                    </span>
                  </span>
                </label>

                <div class="input-wrapper identity-input-wrapper">
                  <i class="bi bi-credit-card-2-front input-icon"></i>
                  <input type="text" class="form-control" placeholder="Enter valid details" formControlName="idProof" />
                  <div class="identity-focus-tooltip">
                    <span class="tooltip-section-label">Verify via</span>
                    <a href="https://myaadhaar.uidai.gov.in/" target="_blank" class="tooltip-link">
                      <i class="bi bi-person-vcard"></i>Aadhaar
                    </a>
                    <a href="https://parivahan.gov.in/" target="_blank" class="tooltip-link">
                      <i class="bi bi-car-front"></i>Driving Licence
                    </a>
                    <a href="https://www.passportindia.gov.in/" target="_blank" class="tooltip-link">
                      <i class="bi bi-passport"></i>Passport
                    </a>
                  </div>
                </div>

                <div *ngIf="
                    registerForm.get('idProof')?.touched && registerForm.get('idProof')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span *ngIf="registerForm.get('idProof')?.errors?.['required']">
                    Identity proof details are required.
                  </span>
                </div>
              </div>
            </div>
            <div class="row align-items-start">
              <div class="col-md-6 mb-3">
                <label class="form-label">Non-Manufacturing Category <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-tag-fill input-icon"></i>
                  <select class="form-select" formControlName="nonMnfgCategory" style="padding-left: 40px">
                    <option value="" disabled selected>Select Category</option>
                    <option *ngFor="let cat of nonMnfgCategoriesList" [value]="cat.id">
                      {{ cat.name }}
                    </option>
                  </select>
                </div>
                <div *ngIf="
                    registerForm.get('nonMnfgCategory')?.touched &&
                    registerForm.get('nonMnfgCategory')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>Category is required.</span>
                </div>
              </div>

              <!-- Identity Proof Attachment -->
              <div class="col-md-6 mb-3">
                <div class="mini-upload-card" [class.uploaded]="uploadedFiles['idProof']"
                  (click)="openUploadPopup('idProof')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['idProof']"
                        [class.bi-cloud-arrow-up-fill]="!uploadedFiles['idProof']"></i>
                    </div>
                    <div class="mini-upload-info">
                      <div class="mini-upload-title">
                        Upload Identity Proof <span class="required-star">*</span>
                      </div>
                      <div class="mini-upload-hint" [class.success]="uploadedFiles['idProof']">
                        <span *ngIf="uploadedFiles['idProof']">
                          Uploaded:
                          {{
                          (uploadedFiles['idProof']?.name?.length || 0) > 20
                          ? (uploadedFiles['idProof']?.name | slice: 0 : 18) + '...'
                          : uploadedFiles['idProof']?.name
                          }}
                        </span>
                        <span *ngIf="!uploadedFiles['idProof']">PDF, Image (Max 2MB)</span>
                      </div>
                    </div>
                  </div>
                  <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['idProof']"
                    [class.bi-chevron-right]="!uploadedFiles['idProof']" [class.done]="uploadedFiles['idProof']"></i>
                </div>
                <div *ngIf="isSubmitted && !uploadedFiles['idProof']" class="text-danger mt-1"
                  style="font-size: 11.5px; font-weight: 500">
                  Identity proof document is required.
                </div>
              </div>
            </div>

            <!-- Non-Manufacturing Category (Dropdown) -->
          </div>
        </div>

        <!-- Step 3: Address Details (activeStep === 2) -->
        <div class="form-step" *ngIf="activeStep === 2">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-geo-alt-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">AGENCY ADDRESS</h3>
          </div>
          <p class="section-desc">Provide your Plant location and Company registration address.</p>

          <div class="row row-gap g-3">
            <div class="col-md-4 mb-3">
              <label class="form-label">Door No <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-house-door input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter door number" formControlName="doorNo" />
              </div>
              <div *ngIf="registerForm.get('doorNo')?.touched && registerForm.get('doorNo')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Door number is required.</span>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">Survey / Field No <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-map input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter survey or field number"
                  formControlName="surveyFieldNo" />
              </div>
              <div *ngIf="
                  registerForm.get('surveyFieldNo')?.touched &&
                  registerForm.get('surveyFieldNo')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Survey/Field No is required.</span>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">Street / Location <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-signpost-split input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter street or specific location"
                  formControlName="streetLocation" />
              </div>
              <div *ngIf="
                  registerForm.get('streetLocation')?.touched &&
                  registerForm.get('streetLocation')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Street/Location is required.</span>
              </div>
            </div>
          </div>

          <div class="row row-gap g-3">
            <div class="col-md-3">
              <label class="form-label">State <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-globe input-icon"></i>
                <input type="hidden" formControlName="state" />

                <input type="text" class="form-control" value="Tamil Nadu" readonly style="padding-left: 40px" />
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">District <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-map input-icon"></i>
                <select class="form-select" formControlName="district" style="padding-left: 40px">
                  <option value="" disabled selected>Select District</option>
                  <option *ngFor="let dist of districts" [value]="dist.id">
                    {{ dist.name || dist }}
                  </option>
                </select>
              </div>
              <div *ngIf="
                  registerForm.get('district')?.touched && registerForm.get('district')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>District is required.</span>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Taluk <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-geo input-icon"></i>
                <select class="form-select" formControlName="taluk" style="padding-left: 40px">
                  <option value="" disabled selected>Select Taluk</option>
                  <option *ngFor="let tk of taluks" [value]="tk.id">{{ tk.name || tk }}</option>
                </select>
              </div>
              <div *ngIf="registerForm.get('taluk')?.touched && registerForm.get('taluk')?.invalid" class="text-danger"
                style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Taluk is required.</span>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Village <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-geo-alt input-icon"></i>
                <select class="form-select" formControlName="village" style="padding-left: 40px">
                  <option value="" disabled selected>Select Village</option>
                  <option *ngFor="let vil of villages" [value]="vil.id">
                    {{ vil.name || vil }}
                  </option>
                </select>
              </div>
              <div *ngIf="registerForm.get('village')?.touched && registerForm.get('village')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Village is required.</span>
              </div>
            </div>
          </div>

          <div class="row row-gap g-3 mt-1">
            <div class="col-md-4">
              <label class="form-label">Pincode <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-pin-angle input-icon"></i>
                <input type="text" class="form-control" placeholder="6-digit postal code" formControlName="pincode"
                  maxlength="6" />
              </div>
              <div *ngIf="registerForm.get('pincode')?.touched && registerForm.get('pincode')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('pincode')?.errors?.['required']">Pincode is required.</span>
                <span *ngIf="registerForm.get('pincode')?.errors?.['pattern']">Must be exactly a 6-digit postal
                  code.</span>
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Latitude</label>
              <div class="input-wrapper">
                <i class="bi bi-compass input-icon"></i>
                <input type="text" class="form-control" placeholder="Select location on map" formControlName="latitude"
                  readonly />
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Longitude</label>
              <div class="input-wrapper">
                <i class="bi bi-compass input-icon"></i>
                <input type="text" class="form-control" placeholder="Select location on map" formControlName="longitude"
                  readonly />
              </div>
            </div>
          </div>

          <div class="location-map-section mb-3">
            <label class="form-label d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-map"></i> Select Plant Location on Map
            </label>
            <p class="map-selection-hint">
              Search for a location, click on the map to place a marker, or drag the marker to
              adjust. Latitude and longitude will be filled automatically.
            </p>
            <div class="input-wrapper location-search-wrapper mb-2">
              <i class="bi bi-search input-icon"></i>
              <input #plantLocationSearch type="text" class="form-control location-search-input"
                placeholder="Search for a location or address" autocomplete="off" />
            </div>
            <div #plantMapContainer class="location-map-container" role="application" aria-label="Plant location map">
            </div>
            <div *ngIf="locationMapError" class="text-danger"
              style="font-size: 11.5px; margin-top: 8px; font-weight: 500">
              {{ locationMapError }}
            </div>
          </div>

          <div class="row row-gap g-3 mt-1 align-items-end">
            <div class="col-md-6">
              <button type="button" class="btn-gps w-100" (click)="detectLocation('plant')"
                style="height: 52px; margin-top: 0">
                <i class="bi bi-geo-alt-fill"></i> Auto-Detect Coordinates (GPS)
              </button>
            </div>

            <div class="col-md-12">
              <label class="form-label d-flex align-items-center gap-2">
                AGENCY PHOTO WITH GPS DETAILS
                <span class="required-star">*</span>

                <i class="bi bi-info-circle-fill text-primary" data-bs-toggle="tooltip" data-bs-placement="top"
                  title="Upload a GPS Map Camera photo with location details." style="cursor: pointer"></i>
              </label>

              <div class="mt-2">
                <div class="mini-upload-card" [class.uploaded]="uploadedFiles['gpsMapCameraPhoto']"
                  (click)="openUploadPopup('gpsMapCameraPhoto')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['gpsMapCameraPhoto']"
                        [class.bi-cloud-arrow-up-fill]="!uploadedFiles['gpsMapCameraPhoto']"></i>
                    </div>

                    <div class="mini-upload-info">
                      <div class="mini-upload-title">
                        AGENCY PHOTO WITH GPS DETAILS
                        <span class="required-star">*</span>
                      </div>

                      <div class="mini-upload-hint" [class.success]="uploadedFiles['gpsMapCameraPhoto']">
                        <span *ngIf="uploadedFiles['gpsMapCameraPhoto']">
                          Uploaded:
                          {{
                          (uploadedFiles['gpsMapCameraPhoto']?.name?.length || 0) > 20
                          ? (uploadedFiles['gpsMapCameraPhoto']?.name | slice: 0 : 18) + '...'
                          : uploadedFiles['gpsMapCameraPhoto']?.name
                          }}
                        </span>

                        <span *ngIf="!uploadedFiles['gpsMapCameraPhoto']">
                          Add the Agency Address Photo
                        </span>
                      </div>
                    </div>
                  </div>

                  <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['gpsMapCameraPhoto']"
                    [class.bi-chevron-right]="!uploadedFiles['gpsMapCameraPhoto']"
                    [class.done]="uploadedFiles['gpsMapCameraPhoto']"></i>
                </div>

                <div *ngIf="isSubmitted && !uploadedFiles['gpsMapCameraPhoto']" class="text-danger"
                  style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  Agency Photo with GPS Details is required.
                </div>
              </div>
            </div>
          </div>

          <!-- YES/NO Option for sameAsPlantAddress -->
          <div class="row mb-4 same-address-box py-3 border-top border-bottom mt-3"
            style="background-color: #f8fafc; border-radius: 6px">
            <div class="col-12 px-3">
              <label class="form-label fw-semibold" style="color: #475569; font-size: 14px">
                Location where ash is to be disposed / stored same as Agency Address?
              </label>
              <div class="d-flex gap-4 align-items-center mt-2">
                <div class="form-check custom-radio">
                  <input type="radio" id="sameAsPlantAddressYes" [value]="true" formControlName="sameAsPlantAddress"
                    class="form-check-input" />
                  <label class="form-check-label ms-1" for="sameAsPlantAddressYes"
                    style="font-weight: 500; cursor: pointer">YES</label>
                </div>
                <div class="form-check custom-radio">
                  <input type="radio" id="sameAsPlantAddressNo" [value]="false" formControlName="sameAsPlantAddress"
                    class="form-check-input" />
                  <label class="form-check-label ms-1" for="sameAsPlantAddressNo"
                    style="font-weight: 500; cursor: pointer">NO</label>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!registerForm.get('sameAsPlantAddress')?.value" class="company-address-section mt-4">
            <div class="section-title d-flex align-items-center gap-2 mb-4">
              <i class="bi bi-geo-alt-fill"></i>
              <h4 class="mb-0 fw-semibold text-uppercase" style="font-size: 15px">
                Location where ash is to be disposed / stored
              </h4>
            </div>

            <div class="row row-gap g-3">
              <div class="col-md-4 mb-3">
                <label class="form-label">Company Door No <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-house input-icon"></i>
                  <input type="text" class="form-control" placeholder="Enter door number"
                    formControlName="companyDoorNo" />
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label">Company Survey / Field No <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-hash input-icon"></i>
                  <input type="text" class="form-control" placeholder="Enter survey or field number"
                    formControlName="companySurveyFieldNo" />
                </div>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label">Company Street / Location <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-signpost-split input-icon"></i>
                  <input type="text" class="form-control" placeholder="Enter street or specific location"
                    formControlName="companyStreetLocation" />
                </div>
              </div>
            </div>

            <div class="row row-gap g-3">
              <div class="col-md-3">
                <label class="form-label">State</label>
                <input type="hidden" formControlName="companyState" />
                <div class="input-wrapper">
                  <i class="bi bi-geo-alt input-icon"></i>
                  <input type="text" class="form-control" value="Tamil Nadu" readonly style="padding-left: 40px" />
                </div>
              </div>

              <div class="col-md-3">
                <label class="form-label">District <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-map input-icon"></i>
                  <select class="form-select" formControlName="companyDistrict" style="padding-left: 40px">
                    <option value="" disabled selected>Select District</option>
                    <option *ngFor="let dist of companyDistricts" [value]="dist.id">
                      {{ dist.name || dist }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <label class="form-label">Taluk <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-geo input-icon"></i>
                  <select class="form-select" formControlName="companyTaluk" style="padding-left: 40px">
                    <option value="" disabled selected>Select Taluk</option>
                    <option *ngFor="let tk of companyTaluks" [value]="tk.id">
                      {{ tk.name || tk }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <label class="form-label">Village <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-geo-alt input-icon"></i>
                  <select class="form-select" formControlName="companyVillage" style="padding-left: 40px">
                    <option value="" disabled selected>Select Village</option>
                    <option *ngFor="let vil of companyVillages" [value]="vil.id">
                      {{ vil.name || vil }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row row-gap g-3 mt-1">
              <div class="col-md-4">
                <label class="form-label">Pincode <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-pin-angle input-icon"></i>
                  <input type="text" class="form-control" placeholder="6-digit postal code"
                    formControlName="companyPincode" maxlength="6" />
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label">Latitude</label>
                <div class="input-wrapper">
                  <i class="bi bi-compass input-icon"></i>
                  <input type="text" class="form-control" placeholder="Select location on map"
                    formControlName="companyLatitude" readonly />
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label">Longitude</label>
                <div class="input-wrapper">
                  <i class="bi bi-compass input-icon"></i>
                  <input type="text" class="form-control" placeholder="Select location on map"
                    formControlName="companyLongitude" readonly />
                </div>
              </div>
            </div>

            <div class="location-map-section mb-3 mt-3">
              <label class="form-label d-flex align-items-center gap-2 mb-1">
                <i class="bi bi-map"></i> Select Company Location on Map
              </label>
              <p class="map-selection-hint">
                Search for a location, click on the map to place a marker, or drag the marker to
                adjust. Latitude and longitude will be filled automatically.
              </p>
              <div class="input-wrapper location-search-wrapper mb-2">
                <i class="bi bi-search input-icon"></i>
                <input #companyLocationSearch type="text" class="form-control location-search-input"
                  placeholder="Search for a company location or address" autocomplete="off" />
              </div>
              <div #companyMapContainer class="location-map-container" role="application"
                aria-label="Company location map"></div>
              <div *ngIf="locationMapError" class="text-danger"
                style="font-size: 11.5px; margin-top: 8px; font-weight: 500">
                {{ locationMapError }}
              </div>
            </div>

            <div class="row row-gap g-3 mt-1 align-items-end">
              <div class="col-md-6">
                <button type="button" class="btn-gps w-100" (click)="detectLocation('company')"
                  style="height: 52px; margin-top: 0">
                  <i class="bi bi-geo-alt-fill"></i> Auto-Detect Company Coordinates
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 4: Categories & Requirements (activeStep === 3) -->
        <div class="form-step" *ngIf="activeStep === 3">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-tags-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Ash Categories & Requirements</h3>
          </div>
          <p class="section-desc">Select your ash requirements and provide required capacity.</p>

          <div class="row row-gap g-3">
            <!-- Capacity Dropdown -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Capacity (MT) <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-truck input-icon"></i>
                <select class="form-select" formControlName="capacity" style="padding-left: 40px">
                  <option value="" disabled selected>Select Capacity</option>
                  <option value="16">16 MT</option>
                  <option value="22">22 MT</option>
                  <option value="28">28 MT</option>
                  <option value="29">29 MT</option>
                  <option value="40">40 MT</option>
                </select>
              </div>
              <div *ngIf="
                  registerForm.get('capacity')?.touched && registerForm.get('capacity')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Capacity is required.</span>
              </div>
            </div>

            <!-- Ash Categories Table (matching trader register) -->
            <div class="col-md-12">
              <label class="form-label" style="text-transform: uppercase; font-weight: bold">ASH CATEGORY <span
                  class="required-star">*</span></label>

              <div class="table-responsive border rounded bg-white">
                <table class="table table-borderless mb-0 align-middle">
                  <thead class="bg-light">
                    <tr>
                      <th scope="col" style="
                          width: 50%;
                          font-size: 12px;
                          font-weight: 600;
                          color: #495057;
                          border-bottom: 1px solid #dee2e6;
                          padding: 10px 16px;
                        ">
                        ASH CATEGORY
                      </th>
                      <th scope="col" style="
                          width: 50%;
                          font-size: 12px;
                          font-weight: 600;
                          color: #495057;
                          border-bottom: 1px solid #dee2e6;
                          padding: 10px 16px;
                        ">
                        Min & Max Load<br />(No. of<br />loads/Quarterly)
                        <div style="
                            color: rgb(122, 204, 28);
                            font-size: 9px;
                            font-weight: 400;
                            margin-top: 2px;
                          ">
                          Issue of the ash is subject to availability
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cat of ashCategoriesList">
                      <td style="padding: 10px 16px; border-bottom: 1px solid #f1f3f5">
                        <div class="form-check d-flex align-items-center mb-0">
                          <input class="form-check-input mt-0 me-2" type="checkbox" [id]="'cat_' + cat.id"
                            [checked]="isAshCategorySelected(cat.id)" (change)="
                              toggleAshCategorySelection(cat.id, $any($event.target).checked)
                            " style="cursor: pointer; width: 18px; height: 18px" />
                          <label class="form-check-label text-secondary mb-0" [for]="'cat_' + cat.id" style="
                              font-size: 13.5px;
                              font-weight: 500;
                              cursor: pointer;
                              padding-left: 4px;
                            ">
                            {{ cat.name }}
                          </label>
                        </div>
                      </td>
                      <td style="padding: 6px 16px; border-bottom: 1px solid #f1f3f5">
                        <ng-container *ngIf="isAshCategorySelected(cat.id)">
                          <ng-container *ngIf="getCategoryFormGroup(cat.id) as catGroup">
                            <div [formGroup]="catGroup" class="d-flex flex-column gap-2">
                              <div class="d-flex gap-2">
                                <div class="flex-grow-1">
                                  <input type="number" class="form-control" formControlName="minLoad" oninput="
                                      if (this.value.length > 4)
                                        this.value = this.value.slice(0, 4);
                                    " style="
                                      background-color: #f8f9fa;
                                      height: 36px;
                                      font-size: 13.5px;
                                      padding: 0 10px;
                                    " placeholder="min 1-10" />
                                  <div class="mt-1" style="font-size: 10px; color: #6c757d; font-weight: 500" *ngIf="
                                      catGroup.get('minLoad')?.value &&
                                      registerForm.get('capacity')?.value
                                    ">
                                    Qty:
                                    {{
                                    (catGroup.get('minLoad')?.value || 0) *
                                    (registerForm.get('capacity')?.value || 0)
                                    }}
                                    MT
                                  </div>
                                </div>
                                <div class="flex-grow-1">
                                  <input type="number" class="form-control" formControlName="maxLoad" oninput="
                                      if (this.value.length > 4)
                                        this.value = this.value.slice(0, 4);
                                    " style="
                                      background-color: #f8f9fa;
                                      height: 36px;
                                      font-size: 13.5px;
                                      padding: 0 10px;
                                    " placeholder="max 10-20" />
                                  <div class="mt-1" style="font-size: 10px; color: #6c757d; font-weight: 500" *ngIf="
                                      catGroup.get('maxLoad')?.value &&
                                      registerForm.get('capacity')?.value
                                    ">
                                    Qty:
                                    {{
                                    (catGroup.get('maxLoad')?.value || 0) *
                                    (registerForm.get('capacity')?.value || 0)
                                    }}
                                    MT
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="catGroup.touched && catGroup.invalid" class="text-danger mt-1"
                                style="font-size: 11.5px; font-weight: 500; line-height: 1.2">
                                <span *ngIf="catGroup.get('minLoad')?.errors?.['required']">Min Load is
                                  required.<br /></span>
                                <span *ngIf="catGroup.get('maxLoad')?.errors?.['required']">Max Load is
                                  required.<br /></span>
                                <span *ngIf="catGroup.get('minLoad')?.errors?.['min']">Minimum Load must be at least
                                  1.<br /></span>
                                <span *ngIf="catGroup.get('maxLoad')?.errors?.['min']">Maximum Load must be at least
                                  1.<br /></span>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="!ashCategoriesList || ashCategoriesList.length === 0" class="text-muted mt-2"
                style="font-size: 13.5px">
                Please select a Power Station to view ash categories.
              </div>
              <div *ngIf="
                  registerForm.get('ashCategoryDetails')?.touched &&
                  registerForm.get('ashCategoryDetails')?.invalid
                " class="text-danger mt-2" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                At least one ash category must be selected and quantities must be valid.
              </div>
            </div>
          </div>
        </div>

        <!-- Step 5: Upload Documents (activeStep === 4) -->
        <div class="form-step" *ngIf="activeStep === 4">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-file-earmark-arrow-up-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Supporting Documents</h3>
          </div>
          <p class="section-desc">Upload necessary clearances and accept declarations.</p>

          <div class="row g-3">
            <!-- Pollution Clearance Certificate -->
            <div class="col-md-6">
              <div class="mini-upload-card" [class.uploaded]="uploadedFiles['pollutionClearance']"
                (click)="openUploadPopup('pollutionClearance')">
                <div class="mini-upload-left">
                  <div class="mini-upload-icon">
                    <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['pollutionClearance']"
                      [class.bi-cloud-arrow-up-fill]="!uploadedFiles['pollutionClearance']"></i>
                  </div>
                  <div class="mini-upload-info">
                    <div class="mini-upload-title">
                      Pollution Control Board Clearance Certificate (NOC)<span class="required-star">*</span>
                    </div>
                    <div class="mini-upload-hint" [class.success]="uploadedFiles['pollutionClearance']">
                      <span *ngIf="uploadedFiles['pollutionClearance']">Uploaded:
                        {{
                        (uploadedFiles['pollutionClearance']?.name?.length || 0) > 20
                        ? (uploadedFiles['pollutionClearance']?.name | slice: 0 : 18) + '...'
                        : uploadedFiles['pollutionClearance']?.name
                        }}</span>
                      <span *ngIf="!uploadedFiles['pollutionClearance']">PDF, Image (Max 2MB)</span>
                    </div>
                  </div>
                </div>
                <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['pollutionClearance']"
                  [class.bi-chevron-right]="!uploadedFiles['pollutionClearance']"
                  [class.done]="uploadedFiles['pollutionClearance']"></i>
              </div>
              <div *ngIf="isSubmitted && !uploadedFiles['pollutionClearance']" class="text-danger mt-2"
                style="font-size: 11.5px; font-weight: 500">
                <i class="bi bi-exclamation-circle"></i> This document is required.
              </div>
            </div>

            <!-- Pre-delivery Inspection Status (Optional) -->
            <div class="col-md-6">
              <div class="mini-upload-card" [class.uploaded]="uploadedFiles['inspectionStatus']"
                (click)="openUploadPopup('inspectionStatus')">
                <div class="mini-upload-left">
                  <div class="mini-upload-icon" style="
                      background: rgba(16, 185, 129, 0.05);
                      color: #059669;
                      border-color: rgba(16, 185, 129, 0.1);
                    ">
                    <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['inspectionStatus']"
                      [class.bi-cloud-arrow-up]="!uploadedFiles['inspectionStatus']"></i>
                  </div>
                  <div class="mini-upload-info">
                    <div class="mini-upload-title">
                      Pre-delivery Inspection Status
                      <span class="text-muted fw-normal" style="font-size: 11px">(Optional)</span>
                    </div>
                    <div class="mini-upload-hint" [class.success]="uploadedFiles['inspectionStatus']">
                      <span *ngIf="uploadedFiles['inspectionStatus']">Uploaded:
                        {{
                        (uploadedFiles['inspectionStatus']?.name?.length || 0) > 20
                        ? (uploadedFiles['inspectionStatus']?.name | slice: 0 : 18) + '...'
                        : uploadedFiles['inspectionStatus']?.name
                        }}</span>
                      <span *ngIf="!uploadedFiles['inspectionStatus']">PDF, Image (Max 2MB)</span>
                    </div>
                  </div>
                </div>
                <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['inspectionStatus']"
                  [class.bi-chevron-right]="!uploadedFiles['inspectionStatus']"
                  [class.done]="uploadedFiles['inspectionStatus']"></i>
              </div>
            </div>
          </div>

          <div class="declaration-box mt-4">
            <div class="declaration-header">
              <div class="declaration-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
              <h4 class="declaration-title">Declarations & Undertaking</h4>
            </div>

            <div class="declaration-check">
              <input type="checkbox" id="declarationCheck" formControlName="declarationCheck" />
              <label for="declarationCheck" style="text-align: justify">
                I hereby declare that all the information provided above is true and correct to the
                best of my knowledge. I understand that my registration may be cancelled if any
                information is found to be false.
              </label>
            </div>

            <div class="declaration-check" style="margin-top: 12px">
              <input type="checkbox" id="declarationCheck2" formControlName="declarationCheck2" />
              <label for="declarationCheck2" style="text-align: justify">
                I agree to abide by the terms and conditions regarding the lifting and transport of
                ash as prescribed by TANGEDCO / TNPGCL.
              </label>
            </div>

            <div *ngIf="
                registerForm.get('declarationCheck2')?.touched &&
                registerForm.get('declarationCheck2')?.invalid
              " class="field-error" style="margin-top: 8px">
              <i class="bi bi-exclamation-circle"></i>
              <span>You must accept the transport terms declaration to proceed.</span>
            </div>
            <div *ngIf="
                registerForm.get('declarationCheck')?.touched &&
                registerForm.get('declarationCheck')?.invalid
              " class="field-error" style="margin-top: 8px">
              <i class="bi bi-exclamation-circle"></i>
              <span>You must accept the truthfulness declaration to proceed.</span>
            </div>
          </div>
        </div>

        <div class="form-actions mt-4">
          <button class="btn-cancel" type="button" routerLink="/login">
            <i class="bi bi-x-lg"></i> Cancel
          </button>
          <div class="d-flex gap-2 ms-auto">
            <button class="btn-cancel" type="button" *ngIf="activeStep > 0" (click)="goToPreviousStep()">
              <i class="bi bi-arrow-left"></i> Previous
            </button>
            <button class="btn-save-draft mx-auto" type="button" (click)="onSaveDraft()" [disabled]="isSavingDraft">
              <span *ngIf="isSavingDraft" class="spinner-border spinner-border-sm me-2" role="status"></span>
              <i *ngIf="!isSavingDraft" class="bi bi-save me-1"></i>
              {{ isSavingDraft ? 'Saving...' : 'Save Draft' }}
            </button>
            <button class="btn-next" type="button" *ngIf="activeStep < 4" (click)="goToNextStep()" [disabled]="false">
              Next Step <i class="bi bi-arrow-right"></i>
            </button>
            <button class="btn-next" type="button" *ngIf="activeStep === 4" (click)="onPreview()">
              Preview Application <i class="bi bi-eye"></i>
            </button>
          </div>
        </div>
        <div class="register-login-link">
          Already have an account? <a routerLink="/login">Sign in here</a>
        </div>
      </form>

      <!-- Preview Mode -->
      <div class="form-step" *ngIf="showFormPreview">
        <div class="section-title d-flex align-items-center gap-2 mb-4">
          <i class="bi bi-eye-fill"></i>
          <h3 class="mb-0 fw-semibold text-uppercase">Preview Application Details</h3>
        </div>
        <p class="section-desc">Review your registration details before confirming submission.</p>

        <div class="preview-layout">
          <!-- Section 1: Initial Verification Details -->
          <div class="preview-section mb-4">
            <h4 class="preview-section-title">
              <i class="bi bi-building-fill me-2"></i>Initial Verification Details
            </h4>
            <div class="row g-3">
              <div class="col-md-6">
                <div class="preview-label">Mobile Number</div>
                <div class="preview-value">
                  +91 {{ registerForm.get('mobileNumber')?.value || 'N/A' }}
                </div>
              </div>
              <div class="col-md-6">
                <div class="preview-label">Power Station</div>
                <div class="preview-value">{{ getStationName() || 'N/A' }}</div>
              </div>
            </div>
          </div>

          <!-- Section 2: Firm Details -->
          <div class="preview-section mb-4">
            <h4 class="preview-section-title">
              <i class="bi bi-buildings-fill me-2"></i>Firm Details
            </h4>
            <div class="row g-3">
              <div class="col-md-6">
                <div class="preview-label">Name of the Agency</div>
                <div class="preview-value fw-semibold">
                  {{ registerForm.get('firmName')?.value || 'N/A' }}
                </div>
              </div>
              <div class="col-md-6">
                <div class="preview-label">Email Address</div>
                <div class="preview-value">
                  {{ registerForm.get('emailAddress')?.value || 'N/A' }}
                </div>
              </div>
              <div class="col-md-12">
                <div class="preview-label">Identity Proof (Aadhaar / DL / Passport)</div>
                <div class="preview-value mono">
                  {{ registerForm.get('idProof')?.value || 'N/A' }}
                </div>
              </div>
              <div class="col-md-12">
                <div class="preview-label">Non-Manufacturer Category</div>
                <div class="preview-value">
                  {{
                  getNonMnfgCategoryName() || registerForm.get('nonMnfgCategory')?.value || 'N/A'
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- Section 3: Address Details -->
          <div class="preview-section mb-4">
            <h4 class="preview-section-title">
              <i class="bi bi-geo-alt-fill me-2"></i>Address Details
            </h4>
            <div class="row g-3">
              <div class="col-md-6">
                <div class="preview-label">Site Address</div>
                <div class="preview-value">
                  Door No. {{ registerForm.get('doorNo')?.value }}, Survey Field No.
                  {{ registerForm.get('surveyFieldNo')?.value }},<br />
                  {{ registerForm.get('streetLocation')?.value }}, {{ getVillageName('plant') }},
                  {{ getTalukName('plant') }},<br />
                  {{ getDistrictName('plant') }}, {{ getStateName('plant') }} -
                  {{ registerForm.get('pincode')?.value }}
                </div>
                <div class="preview-gps mt-2 text-muted" style="font-size: 12px"
                  *ngIf="registerForm.get('latitude')?.value">
                  <i class="bi bi-compass me-1"></i> GPS: {{ registerForm.get('latitude')?.value }},
                  {{ registerForm.get('longitude')?.value }}
                </div>
              </div>
              <div class="col-md-6">
                <div class="preview-label">Registered Office Address</div>
                <div class="preview-value" *ngIf="registerForm.get('sameAsPlantAddress')?.value">
                  <span class="badge bg-success-subtle text-success border border-success-subtle px-2 py-1">Same as
                    Plant Address</span>
                </div>
                <div class="preview-value" *ngIf="!registerForm.get('sameAsPlantAddress')?.value">
                  Door No. {{ registerForm.get('companyDoorNo')?.value }}, Survey Field No.
                  {{ registerForm.get('companySurveyFieldNo')?.value }},<br />
                  {{ registerForm.get('companyStreetLocation')?.value }},
                  {{ getVillageName('company') }}, {{ getTalukName('company') }},<br />
                  {{ getDistrictName('company') }}, {{ getStateName('company') }} -
                  {{ registerForm.get('companyPincode')?.value }}
                </div>
                <div class="preview-gps mt-2 text-muted" style="font-size: 12px" *ngIf="
                    !registerForm.get('sameAsPlantAddress')?.value &&
                    registerForm.get('companyLatitude')?.value
                  ">
                  <i class="bi bi-compass me-1"></i> GPS:
                  {{ registerForm.get('companyLatitude')?.value }},
                  {{ registerForm.get('companyLongitude')?.value }}
                </div>
              </div>
            </div>

            <!-- Maps Row -->
            <div class="row g-3 mt-1">
              <div [ngClass]="registerForm.get('sameAsPlantAddress')?.value ? 'col-12' : 'col-md-6'"
                *ngIf="registerForm.get('latitude')?.value">
                <div class="preview-map-section mt-1">
                  <div #previewPlantMapContainer class="location-map-container preview-location-map" role="img"
                    aria-label="Site location preview map"></div>
                </div>
              </div>

              <div class="col-md-6" *ngIf="
                  !registerForm.get('sameAsPlantAddress')?.value &&
                  registerForm.get('companyLatitude')?.value
                ">
                <div class="preview-map-section mt-1">
                  <div #previewCompanyMapContainer class="location-map-container preview-location-map" role="img"
                    aria-label="Registered office location preview map"></div>
                </div>
              </div>
            </div>
            <div *ngIf="previewMapError" class="text-danger mt-2" style="font-size: 11.5px; font-weight: 500">
              {{ previewMapError }}
            </div>
          </div>

          <!-- Section 4: Categories & Requirements -->
          <div class="preview-section mb-4">
            <h4 class="preview-section-title">
              <i class="bi bi-tags-fill me-2"></i>Ash Categories & Requirements
            </h4>
            <div class="row g-3">
              <div class="col-md-6">
                <div class="preview-label">Ash Product Type</div>
                <div class="preview-value">
                  <span *ngFor="let prod of getSelectedProducts()" class="badge bg-light text-dark border me-1">{{
                    prod.name }}</span>
                  <span *ngIf="getSelectedProducts().length === 0">N/A</span>
                </div>
              </div>
              <div class="col-md-6" *ngIf="isOthersProductSelected()">
                <div class="preview-label">Other Product Description</div>
                <div class="preview-value">
                  {{ registerForm.get('productDescription')?.value || 'N/A' }}
                </div>
              </div>
              <div class="col-md-6">
                <div class="preview-label">Capacity (MT)</div>
                <div class="preview-value">
                  {{
                  registerForm.get('capacity')?.value
                  ? registerForm.get('capacity')?.value + ' MT'
                  : 'N/A'
                  }}
                </div>
              </div>

              <div class="col-md-12">
                <div class="preview-label mb-2">Requested Ash Categories</div>
                <div class="table-responsive border rounded" *ngIf="getSelectedAshCategories().length > 0">
                  <table class="table table-sm table-striped mb-0 align-middle">
                    <thead class="bg-light">
                      <tr>
                        <th class="ps-3 py-2" style="font-size: 12px">Ash Category</th>
                        <th class="py-2 text-center" style="font-size: 12px">Min Load</th>
                        <th class="py-2 text-center" style="font-size: 12px">Max Load</th>
                        <th class="py-2 text-center" style="font-size: 12px">Min Quantity (MT)</th>
                        <th class="pe-3 py-2 text-center" style="font-size: 12px">
                          Max Quantity (MT)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let cat of getSelectedAshCategories()">
                        <td class="ps-3 py-2 fw-medium" style="font-size: 13px">
                          {{ cat.name }}
                        </td>
                        <td class="py-2 text-center text-muted" style="font-size: 13px">
                          {{ cat.minLoad || 'N/A' }}
                        </td>
                        <td class="py-2 text-center text-muted" style="font-size: 13px">
                          {{ cat.maxLoad || 'N/A' }}
                        </td>
                        <td class="py-2 text-center text-muted" style="font-size: 13px">
                          {{ cat.minQty || 'N/A' }}
                        </td>
                        <td class="pe-3 py-2 text-center fw-semibold text-dark" style="font-size: 13px">
                          {{ cat.maxQty || 'N/A' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div *ngIf="getSelectedAshCategories().length === 0" class="text-muted small">
                  No ash categories selected.
                </div>
              </div>
            </div>
          </div>

          <!-- Section 5: Uploaded Documents -->
          <div class="preview-section mb-4">
            <h4 class="preview-section-title">
              <i class="bi bi-file-earmark-arrow-up-fill me-2"></i>Uploaded Documents
            </h4>
            <div class="row g-3">
              <div class="col-md-12">
                <div class="d-flex flex-wrap gap-2">
                  <!-- idProof Document -->
                  <div class="p-2 border rounded d-flex align-items-center justify-content-between bg-white"
                    style="width: calc(50% - 8px); min-width: 280px" *ngIf="uploadedFiles['idProof']">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-file-earmark-check-fill text-success fs-5 me-2"></i>
                      <div class="d-flex flex-column text-start">
                        <span class="fw-medium text-dark" style="font-size: 13px">Identity Proof Document</span>
                        <span class="text-muted" style="font-size: 11px">{{
                          uploadedFiles['idProof']?.name
                          }}</span>
                      </div>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-primary py-1 px-2"
                      (click)="viewUploadedFile(uploadedFiles['idProof'], 'idProof')" style="font-size: 12px">
                      View
                    </button>
                  </div>

                  <!-- Pollution Clearance -->
                  <div class="p-2 border rounded d-flex align-items-center justify-content-between bg-white"
                    style="width: calc(50% - 8px); min-width: 280px" *ngIf="uploadedFiles['pollutionClearance']">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-file-earmark-check-fill text-success fs-5 me-2"></i>
                      <div class="d-flex flex-column text-start">
                        <span class="fw-medium text-dark" style="font-size: 13px">Pollution Clearance Certificate
                          (CTO)</span>
                        <span class="text-muted" style="font-size: 11px">{{
                          uploadedFiles['pollutionClearance']?.name
                          }}</span>
                      </div>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-primary py-1 px-2" (click)="
                        viewUploadedFile(uploadedFiles['pollutionClearance'], 'pollutionClearance')
                      " style="font-size: 12px">
                      View
                    </button>
                  </div>

                  <!-- Pre-delivery Inspection Status -->
                  <div class="p-2 border rounded d-flex align-items-center justify-content-between bg-white"
                    style="width: calc(50% - 8px); min-width: 280px" *ngIf="uploadedFiles['inspectionStatus']">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-file-earmark-check-fill text-success fs-5 me-2"></i>
                      <div class="d-flex flex-column text-start">
                        <span class="fw-medium text-dark" style="font-size: 13px">Pre-delivery Inspection Status</span>
                        <span class="text-muted" style="font-size: 11px">{{
                          uploadedFiles['inspectionStatus']?.name
                          }}</span>
                      </div>
                    </div>
                    <button type="button" class="btn btn-sm btn-outline-primary py-1 px-2" (click)="
                        viewUploadedFile(uploadedFiles['inspectionStatus'], 'inspectionStatus')
                      " style="font-size: 12px">
                      View
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions mt-4">
          <button type="button" class="btn-cancel" (click)="closePreview()">
            <i class="bi bi-arrow-left"></i> Back to Edit
          </button>
          <button type="button" class="btn-next ms-auto" (click)="submitFromPreview()">
            Confirm & Submit <i class="bi bi-check-circle"></i>
          </button>
        </div>
      </div>
    </div>
  </main>
</div>

<!-- Upload Popup Modal -->
<div *ngIf="activeUploadDocKey" class="upload-modal-backdrop">
  <div class="upload-modal-content">
    <div class="modal-header">
      <h3>Upload {{ docLabels[activeUploadDocKey] }}</h3>
      <button type="button" class="modal-close-btn" (click)="closeUploadPopup()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-upload-zone">
      <i class="bi bi-cloud-arrow-up-fill"></i>
      <div class="zone-title">Drag and drop file here, or click to browse</div>
      <div class="zone-hint">Supported formats: PDF, JPEG, PNG (Max 2MB)</div>
      <input type="file" (change)="onModalFileSelected($event)" />
    </div>

    <div *ngIf="selectedFileForUpload" class="selected-file-box">
      <div class="selected-file-info">
        <i class="bi bi-file-earmark-text"></i>
        <span>{{ selectedFileForUpload.name }}</span>
      </div>
      <button type="button" class="file-remove-btn" (click)="selectedFileForUpload = null">
        <i class="bi bi-trash"></i>
      </button>
    </div>

    <div class="modal-actions">
      <button type="button" class="btn-cancel" (click)="closeUploadPopup()">Cancel</button>
      <button type="button" class="btn-next" [disabled]="!selectedFileForUpload || isUploading"
        (click)="confirmUpload()">
        <i class="bi bi-cloud-check-fill" *ngIf="!isUploading"></i>
        <span *ngIf="!isUploading">Confirm Upload</span>
        <span *ngIf="isUploading">Uploading...</span>
      </button>
    </div>
  </div>
</div>

<!-- Document Preview Modal -->
<div class="custom-modal-backdrop" *ngIf="previewDocumentUrl">
  <div class="custom-modal-content"
    style="max-width: 1400px; width: 95%; height: 95vh; display: flex; flex-direction: column">
    <div class="modal-header d-flex justify-content-between align-items-center py-2 px-3 border-bottom bg-light">
      <h3 class="modal-title mb-0 fs-6 fw-bold">
        <i class="bi bi-file-earmark-text text-primary me-2"></i> Document Preview
      </h3>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
          (click)="downloadPreviewDocument()" title="Download Document">
          <i class="bi bi-download"></i> Download
        </button>
        <button class="btn-close-modal" (click)="closeDocumentPreview()" style="
            background: none;
            border: none;
            font-size: 1.2rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            transition: background-color 0.2s;
          " onmouseover="this.style.backgroundColor = '#e9ecef'"
          onmouseout="this.style.backgroundColor = 'transparent'">
          <i class="bi bi-x-lg text-secondary" style="font-size: 1rem"></i>
        </button>
      </div>
    </div>
    <div class="modal-body flex-grow-1 p-0" style="position: relative; background: #525659; overflow: hidden">
      <iframe [src]="previewDocumentUrl" style="width: 100%; height: 100%; border: none; display: block"></iframe>
    </div>
  </div>
</div>